"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadDocumentIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 24 24" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M20 23.5H4C3.17157 23.5 2.5 22.8284 2.5 22V2C2.5 1.17157 3.17157 0.5 4 0.5H13.5C13.6875 0.5 13.8674 0.574498 14 0.707106L21.2929 8C21.4255 8.13261 21.5 8.31246 21.5 8.5V22C21.5 22.8284 20.8284 23.5 20 23.5Z", stroke: "black", strokeWidth: "1", fill: fill }, void 0),
            jsx_runtime_1.jsx("path", { d: "M12 9L12 19M12 19L15 15.6667M12 19L9 15.6667", stroke: "black", strokeWidth: "1", strokeLinecap: "round", strokeLinejoin: "round" }, void 0)] }), void 0));
};
var BigSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 32 32" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M27.3334 31.25H4.66669C3.97633 31.25 3.41669 30.6904 3.41669 30V2C3.41669 1.30964 3.97633 0.75 4.66669 0.75H18C18.228 0.75 18.4466 0.840557 18.6078 1.00175L19.1381 0.471418L18.6078 1.00175L28.2172 10.6112C28.4503 10.8443 28.5834 11.1665 28.5834 11.5V30C28.5834 30.6904 28.0237 31.25 27.3334 31.25Z", stroke: "black", strokeWidth: "1.5", fill: fill }, void 0),
            jsx_runtime_1.jsx("path", { d: "M16 12L16 25.3334M16 25.3334L20 20.8889M16 25.3334L12 20.8889", stroke: "black", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }, void 0)] }), void 0));
};
var DownloadDocumentIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.DownloadDocumentIcon = DownloadDocumentIcon;
//# sourceMappingURL=DownloadDocumentIcon.js.map